import { useEffect, useState } from "react";

// Phone-width screens (below Tailwind's `md`), where the admin layout shows its
// navigation as a drawer instead of a side rail.
const QUERY = "(max-width: 767px)";

const matches = () =>
  typeof window !== "undefined" && typeof window.matchMedia === "function"
    ? window.matchMedia(QUERY).matches
    : false;

export default function useIsMobile() {
  const [isMobile, setIsMobile] = useState(matches);

  useEffect(() => {
    if (typeof window.matchMedia !== "function") return undefined;
    const media = window.matchMedia(QUERY);
    const onChange = () => setIsMobile(media.matches);
    onChange();
    media.addEventListener?.("change", onChange);
    return () => media.removeEventListener?.("change", onChange);
  }, []);

  return isMobile;
}
